import store from "../store";
import { isTokenValid, refreshSession } from "@/shared/token";
import { accessAllows } from "@/shared/permissions";
import { PRIMARY_NAVIGATION, SECONDARY_NAVIGATION } from "@/shared/navigation";

export default async (to, from, next) => {
  if (!to.name) return next("/sign-in");

  // No refresh o guard da primeira rota roda antes do App.vue ler a sessao
  // do localStorage: sem isto o admin logado caia no /sign-in a cada F5.
  if (!store.getters.authenticated) await store.dispatch("initializeStore");

  // Sessao so conta com token dentro da validade. Vencido, tenta renovar com
  // o refresh; sem renovacao, sai -- token vencido no storage deixava o admin
  // "logado" numa tela em que toda chamada voltava 401.
  if (
    store.getters.authenticated &&
    !isTokenValid(store.getters.token) &&
    !(await refreshSession())
  ) {
    await store.dispatch("setUser", null);
    await store.dispatch("setToken", null);
    await store.dispatch("setRefreshToken", null);
    await store.dispatch("setAccess", null);
  }

  const requiredAuth = to.meta.requiredAuth === true;
  const authenticated = store.getters.authenticated;

  if (to.path === "/sign-in" && authenticated) {
    document.title = "Dashboard - Pitch Admin";
    return next("/cockpit");
  }

  if (requiredAuth && !authenticated) {
    return next({ path: "/sign-in", query: { redirect: to.fullPath } });
  }

  // Perfil e permissoes: lidos da API uma vez por carga da pagina, para uma
  // mudanca de perfil valer no F5 sem precisar sair e entrar.
  if (requiredAuth && !store.getters.accessLoaded) {
    await store.dispatch("loadAccess");
  }

  if (requiredAuth && !routeAllowed(to)) {
    const fallback = firstAllowedPath();
    // Ja na tela de destino (ou sem nenhuma liberada): "Sem acesso".
    if (!fallback || fallback === to.path) return next("/sem-acesso");
    return next(fallback);
  }

  document.title = to.name + " - Pitch Admin";
  next();
};

// Toda rota casada (pai e filha) precisa liberar o acesso.
function routeAllowed(to) {
  const access = store.getters.access;
  return to.matched.every((record) => {
    const rule = record.meta?.permission;
    return accessAllows(access, typeof rule === "function" ? rule(to) : rule);
  });
}

function firstAllowedPath() {
  const access = store.getters.access;
  const item = PRIMARY_NAVIGATION.concat(SECONDARY_NAVIGATION).find(
    (entry) => entry.permission && accessAllows(access, entry.permission)
  );
  return item?.path || null;
}
